<div class="container container_type_main">
  <div class="page-control">
    <span (click)="back()" class="page-control__backlink with-icon">{{ 'back-to-tracks' | translate }}</span>
  </div>

  <div class="artist" *ngIf="artist">
    <div class="artist__image artist__image-circle">
      <img [src]="artist.pictureUrl" [alt]="artist.title" appReplaceMissingImage>
    </div>
    <div class="artist__content">
      <div class="artist__name">{{artist.title}}</div>
      <div class="artist__info" *ngIf="melodiesCount">{{ 'artist-page.info' | translate: {count: melodiesCount} }}</div>
    </div>
  </div>

  <div class="subtitle h2">{{ 'artist-page.melodies' | translate }}</div>
  <div class="songs-list">
    <div *ngFor="let melody of melodies" class="songs-list__item" app-melody-item [melody]="melody"></div>
  </div>

  <div class="full-button" *ngIf="this.melodies.length < this.melodiesCount" (click)="loadMelodiesPage()">
    <div class="button button_type_light">{{ 'show-more' | translate }}</div>
  </div>

  <app-privet-plus-banner [specialBanners]="mainPageSpecialBanners"></app-privet-plus-banner>
</div>
